import React, { Component } from "react";
import { formatAmount } from "../lib/payment-utils";

/**
 * Renders the shopping cart billing summary. 
 * It uses table to show the bill summary details.
 * expected properties:
 *  idx
 *  payment
 *  state
 *  config
 */
class ShoppingCartBillSummary extends Component {
  render() {
    const { config, payment, idx, state } = this.props,
      { messages, channelCode } = config;
    const liability = payment.liability || {};
    const dueDateFormat = messages["payment.dueDate.format"] || "MM/DD/YYYY";
    return (
      <div className="col-md-6">
        <div className="opp-account-details-table">
          <table className="table table-payment-info table-sm-custom table-bordered-simple table-vertical-middle">
            <tbody>
              <tr className="subsection-title">
                <td colSpan="2">{messages["billSummary.header"]}</td>
              </tr>
              <tr>
                <td className="payment-info-label-col">
                  {messages["payment.amountDue.label"]}
                </td>
                <td className="payment-info-value-col text-right">
                  {formatAmount(liability.amountDue || 0)}
                </td>
              </tr>
              <tr>
                <td className="payment-info-label-col">
                  {messages["payment.dueDate.label"]}
                </td>
                <td className="payment-info-value-col text-right">
                  {moment(liability.dueDate, "MMDDYYYY").format(dueDateFormat)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default ShoppingCartBillSummary;
